/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetComponentLookupResponseDto
 */
export interface AssetComponentLookupResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetComponentLookupResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentLookupResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the AssetComponentLookupResponseDto interface.
 */
export function instanceOfAssetComponentLookupResponseDto(value: object): value is AssetComponentLookupResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetComponentLookupResponseDtoFromJSON(json: any): AssetComponentLookupResponseDto {
    return AssetComponentLookupResponseDtoFromJSONTyped(json, false);
}

export function AssetComponentLookupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetComponentLookupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AssetComponentLookupResponseDtoToJSON(json: any): AssetComponentLookupResponseDto {
    return AssetComponentLookupResponseDtoToJSONTyped(json, false);
}

export function AssetComponentLookupResponseDtoToJSONTyped(value?: AssetComponentLookupResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

